<template>
    <div class="right-banner_ext" />
</template>
<script>
export default {};
</script>
